import { Breadcrumb, Layout, Menu, Modal, Row, Col, Button, Carousel, Upload, Card, ConfigProvider, Tabs, Typography, message } from 'antd';
import React, { useEffect, useState, useRef, useContext } from 'react';
import styled from 'styled-components';
import ShareLearningModal from './ShareLearningModal';
import { Navigate, Outlet, useNavigate, useLocation } from 'react-router-dom'
import { EditOutlined, ArrowRightOutlined, PlusOutlined } from '@ant-design/icons';
import axios from 'axios';
import Label_language from '../../language';
import Carousel_news_ticker from './Carousel_news_ticker';
const { Title, Paragraph, Text, Link } = Typography;
const label_language = Label_language.cramschool.children.Common.children
const BlogCard = ({
    handleOnShow = () => { },
    edit,
    data,
    span,
    handleOnEdit,
    type,
    page,
    lesson_show,
    set_lesson_show,
}) => {
    const [dimensions, setDimensions] = useState({
        height: window.innerHeight,
        width: window.innerWidth
    });
    const language = useContext(ConfigProvider.ConfigContext).locale.locale
    const navigate = useNavigate();
    useEffect(() => {
        const debouncedHandleResize = function handleResize() {
            setDimensions({
                height: window.innerHeight,
                width: window.innerWidth
            });
        };

        window.addEventListener("resize", debouncedHandleResize);

        return _ => {
            window.removeEventListener("resize", debouncedHandleResize);
        };
    }, [])
    const handleNavigate = (blog_id, order_stage_id) => {
        if (page == 'Teachers') {
            navigate('/cramSchool/Teachers')
        } else if (page == 'ClassIntroduce') {
            if (order_stage_id == 1) {
                add_count(blog_id);
                navigate(`/cramSchool/Lesson/${blog_id}`)
            } else {
                add_count(blog_id);
                navigate(`/cramSchool/${page}/${blog_id}`)
            }
        } else {
            add_count(blog_id);
            navigate(`/cramSchool/${page}/${blog_id}`)
        }
    }
    const add_count = (blog_id) => {
        axios
            .patch('/cramSchool/api/blog/view_count', { blog_id: blog_id })
            .then((response) => {
            })
    }
    const handleAdd = (blog_id) => {
        add_count(blog_id);
        navigate(`/cramSchool/${page}/${blog_id}`)
    }
    const handleAddPic = (blog_id, order_stage_id) => {
        if (page == 'Teachers') {
            return '/cramSchool/Teachers'
        } else if (page == 'ClassIntroduce') {
            if (order_stage_id == 1) {
                add_count(blog_id);
                return `/cramSchool/Lesson/${blog_id}`
            } else {
                add_count(blog_id);
                return `/cramSchool/${page}/${blog_id}`
            }
        } else {
            add_count(blog_id);
            return `/cramSchool/${page}/${blog_id}`
        }
        // page == 'Teachers' ? '/cramSchool/Teachers' :
        //     page == 'ClassIntroduce' ? value.order_stage_id == 1 ? `/cramSchool/Lesson/${value.blog_id}` :
        //         `/cramSchool/${page}/${value.blog_id}` : page != 'NewCourse' ?
        //         `/cramSchool/${page}/${value.blog_id}` : null
    }
    return (
        <>
            {data && data.map((value, index) => {
                if (type == 'straight') {
                    return (
                        < Col sm={{ span: 24 }
                        } md={{ span: span }} justify='center' style={{ position: 'relative', minWidth: dimensions['width'] < 500 ? '100%' : 'auto' }}>
                            <Card
                                hoverable
                                bodyStyle={{
                                    minHeight: '15rem',
                                    maxHeight: '15rem',
                                    position: 'relative',
                                }}

                                cover={(
                                    <>
                                        {edit ? <>
                                            <Row style={{ position: 'relative', justifyContent: 'end', }}>
                                                <Col className='example' style={{ position: 'absolute', left: '90%', top: '0%', zIndex: 99 }}>
                                                    <EditOutlined
                                                        className='example'
                                                        style={{
                                                            backgroundColor: '#F9D4E5',
                                                            fontSize: '1.2rem',
                                                            borderRadius: '50%',
                                                            padding: '8px'
                                                        }}
                                                        onClick={e => handleOnEdit(index)}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                            : null}
                                        {/* {page == 'ClassIntroduce' || page == 'Teachers' ? <>
                                            <Row style={{ backgroundColor: value.background_color, minHeight: "18rem", alignItems: 'center' }} >
                                                <Col span={22}></Col>
                                                <Col span={24} style={{ position: 'relative' }}>
                                                    <div style={{ padding: '3%' }}>
                                                        <Carousel_news_ticker file_url={value['file_url']} url={page == 'Teachers' ? '/cramSchool/Teachers' : `/cramSchool/${page}/${value['blog_id']}`} backgroundColor={'#FFFFFF'} />
                                                    </div>
                                                </Col>
                                                {value.enroll_status == 1 ?
                                                    <div style={{ position: 'absolute', top: '-3%', left: '-8%' }}>
                                                        <Row style={{ position: 'relative' }}>
                                                            <svg preserveAspectRatio="xMidYMid meet" data-bbox="20 20 160 160" viewBox="20 20 160 160" height="70" width="70" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="presentation" aria-hidden="true" aria-labelledby="svgcid-4o9xopzbj1a5">
                                                                <g>
                                                                    <path fill={value.enroll_status_background_color || 'red'} d="M178.301 116.439l-8.246 5.784 3.402 9.481-8.878 3.872 1.469 9.576-9.831 2.189-.485 10.062-9.685.181-2.306 9.409-9.921-1.74-4.295 9.104-9.017-3.538-5.73 7.809-8.499-5.402L98.826 180l-6.977-6.721-8.282 5.024-5.787-8.248-9.481 3.405-3.874-8.88-9.574 1.473-2.19-9.831-10.061-.485-.18-9.684-9.41-2.306 1.74-9.92-9.112-4.297 3.54-9.019-7.812-5.73 5.405-8.501L20 98.822l6.722-6.975-5.024-8.285 8.245-5.783-3.404-9.478 8.88-3.873-1.473-9.575 9.831-2.189.483-10.064 9.686-.18 2.305-9.411 9.923 1.741 4.298-9.109 9.016 3.539 5.731-7.81 8.5 5.403L101.174 20l6.977 6.722 8.283-5.024 5.785 8.246 9.48-3.402 3.873 8.878 9.574-1.47 2.19 9.829 10.059.484.181 9.685 9.409 2.305-1.739 9.923 9.112 4.299-3.539 9.018 7.81 5.73-5.403 8.501 6.774 7.457-6.723 6.976 5.024 8.282z"></path>
                                                                </g>
                                                            </svg>
                                                            <div style={{ position: 'absolute', top: '30%', left: '15%', color: value.enroll_status_font_color || '#FFFFFF', fontSize: '1rem', letterSpacing: '2px' }}>
                                                                {label_language.enrolling[language] && '招生中'}
                                                            </div>
                                                        </Row>
                                                    </div> : null
                                                }
                                            </Row>
                                        </> : <> */}
                                        {/* <Col span={24} style={{ position: 'relative' }}> */}
                                        {/* <div onClick={e => page == 'Teachers' ? navigate('/cramSchool/Teachers') : page == 'ClassIntroduce' ? value.order_stage_id == 1 ? navigate(`/cramSchool/Lesson/${value.blog_id}`) : navigate(`/cramSchool/${page}/${value.blog_id}`) : navigate(`/cramSchool/${page}/${value.blog_id}`)}> */}
                                        <div onClick={e => handleAdd(value.blog_id, value.order_stage_id)}>
                                            <Carousel_news_ticker
                                                style={{ position: 'relative' }}
                                                file_url={value['file_url']}
                                                // url={page == 'Teachers' ? '/cramSchool/Teachers' : `/cramSchool/${page}/${value['blog_id']}`}
                                                //  value.order_stage_id == 1 ? set_lesson_show(value.blog_id) :
                                                backgroundColor={value.pic_background_color || '#FFFFFF'}
                                            />
                                        </div>
                                        {/* </div> */}
                                        {/* </Col> */}
                                        {value.enroll_status == 1 ?
                                            <div style={{ position: 'absolute', top: '-2%', left: '-2%' }}>
                                                <Row style={{ position: 'relative' }}>
                                                    <svg preserveAspectRatio="xMidYMid meet" data-bbox="20 20 160 160" viewBox="20 20 160 160" height="70" width="70" xmlns="http://www.w3.org/2000/svg" data-type="shape" role="presentation" aria-hidden="true" aria-labelledby="svgcid-4o9xopzbj1a5">
                                                        <g>
                                                            <path fill={value.enroll_status_background_color || 'red'} d="M178.301 116.439l-8.246 5.784 3.402 9.481-8.878 3.872 1.469 9.576-9.831 2.189-.485 10.062-9.685.181-2.306 9.409-9.921-1.74-4.295 9.104-9.017-3.538-5.73 7.809-8.499-5.402L98.826 180l-6.977-6.721-8.282 5.024-5.787-8.248-9.481 3.405-3.874-8.88-9.574 1.473-2.19-9.831-10.061-.485-.18-9.684-9.41-2.306 1.74-9.92-9.112-4.297 3.54-9.019-7.812-5.73 5.405-8.501L20 98.822l6.722-6.975-5.024-8.285 8.245-5.783-3.404-9.478 8.88-3.873-1.473-9.575 9.831-2.189.483-10.064 9.686-.18 2.305-9.411 9.923 1.741 4.298-9.109 9.016 3.539 5.731-7.81 8.5 5.403L101.174 20l6.977 6.722 8.283-5.024 5.785 8.246 9.48-3.402 3.873 8.878 9.574-1.47 2.19 9.829 10.059.484.181 9.685 9.409 2.305-1.739 9.923 9.112 4.299-3.539 9.018 7.81 5.73-5.403 8.501 6.774 7.457-6.723 6.976 5.024 8.282z"></path>
                                                        </g>
                                                    </svg>
                                                    <div style={{ position: 'absolute', top: '30%', left: '2%', color: value.enroll_status_font_color || '#FFFFFF', fontSize: '1rem', letterSpacing: '2px', fontWeight: 'bolder', zIndex: 99 }}>
                                                        {label_language.enrolling[language] && '招生中'}
                                                    </div>
                                                </Row>
                                            </div> : null
                                        }
                                        {/* </>} */}
                                    </>)
                                }
                                style={{ backgroundColor: value.background_color || '#ffef9882' }}
                            >
                                <Row justify={page == 'NewCourse' ? 'center' : 'end'} gutter={[16, 16]} onClick={e => handleNavigate(value.blog_id, value.order_stage_id)}>
                                    <Col span={24} style={{ fontSize: '1.5rem', color: value.font_color || 'black' }}>{value['title']}</Col>
                                    <Col span={24} >
                                        <Paragraph
                                            style={{ color: value.font_color || 'black' }}
                                            ellipsis={{
                                                rows: 3,
                                                expandable: true,
                                                symbol: 'more',
                                            }}
                                        >
                                            {value['content']}
                                        </Paragraph>
                                    </Col>
                                    {page == 'NewCourse' ?
                                        <Col style={{ position: 'absolute', bottom: '15px', }} span={24} >
                                            <Row justify={'space-between'} gutter={40}>
                                                <Col style={{ color: value.font_color || 'black' }}>
                                                    目前已報名人數：{value.student_count}人
                                                </Col>
                                                <Col className='example' onClick={e => handleOnShow(value.class_id)}>
                                                    <span style={{ cursor: 'pointer', color: value.font_color || 'black' }} >{label_language.appointment[language] && '填單預約'}</span>
                                                    <ArrowRightOutlined style={{ color: value.font_color || 'black' }} />
                                                </Col>
                                            </Row>
                                        </Col>
                                        :
                                        <Col style={{ position: 'absolute', bottom: '10px', right: '10px' }} >
                                            {page == 'ClassIntroduce' || page == 'Class' ? <>
                                                <Col>
                                                    {/* <Typography.Text
                                            type="secondary"
                                            style={{
                                                fontSize: '12px'
                                            }}
                                        >
                                            {props.label_language?.click_time[language] && '點擊次數'}：{visit_time[`/cramSchool/ClassIntroduce/${value['blog_id']}`]}
                                        </Typography.Text> */}
                                                </Col>
                                                <Col className='example'>
                                                    <span style={{ textDecoration: 'underline', cursor: 'pointer', color: value.font_color || 'black' }} onClick={e => handleNavigate(value.blog_id, value.order_stage_id)}>{label_language.learn_more[language] && '了解更多'}</span>
                                                    <ArrowRightOutlined style={{ color: value.font_color || 'black' }} onClick={e => handleNavigate(value.blog_id, value.order_stage_id)} />
                                                </Col>
                                            </> : <>
                                                <span style={{ fontSize: '12px', color: value.font_color || '#999997' }}>{value['annoucement_time']}</span>
                                            </>}
                                        </Col>}
                                </Row >
                            </Card >
                        </Col >
                    )
                } else if (type == 'horizontal') {
                    return (
                        < Col sm={{ span: 24 }
                        } md={{ span: 12 }} justify='center' >
                            <Card
                                hoverable
                                onClick={e => page == 'Environment' ? navigate('/cramSchool/Environment') : handleAdd(value.blog_id)}
                            // style={{ minHeight: "17rem", position: 'relative', alignItems: 'center' }}
                            // style={{ backgroundColor: value.background_color || '#ffffff' }}
                            >
                                <Row gutter={[24, 16]} style={{ minHeight: "15rem", position: 'relative', alignItems: 'center' }}>
                                    <Col span={12} >
                                        <Col span={24} >
                                            <Carousel_news_ticker file_url={value['file_url']} />
                                        </Col>
                                        {/* <Col style={{ position: 'absolute', left: '95%', top: '-3%' }}>
                                        <Button size='large' shape="circle" icon={<EditOutlined />} style={{ position: 'absolute', top: 0, backgroundColor: '#F9D4E5' }} onClick={e => handleOnEdit(index)} />
                                    </Col> */}
                                    </Col>
                                    <Col span={12} >
                                        < Row gutter={[8, 8]} >
                                            <Col span={24}>
                                                <span style={{ fontSize: '1.2rem', fontWeight: 'bold', color: value.font_color || 'black' }}>{value['title']}</span>
                                            </Col>
                                            {dimensions['width'] > 500 &&
                                                (<Col span={24}>
                                                    <Paragraph
                                                        style={{ color: value.font_color || 'black' }}
                                                        ellipsis={{
                                                            rows: 2,
                                                            expandable: true,
                                                            symbol: 'more',
                                                        }}
                                                    >
                                                        {value['content']}
                                                    </Paragraph>
                                                </Col>)}
                                            <Col span={24}>
                                                <span style={{ fontSize: '0.9rem', color: value.font_color || '#00000040' }}>{value['last_edit_time']}</span>
                                            </Col>
                                            {page == 'Class' ? <>
                                                <Col style={{ position: 'absolute', bottom: '-30px', right: '0px' }} className='example'>
                                                    <span style={{ textDecoration: 'underline', fontSize: '16px', cursor: 'pointer', color: value.font_color || 'black' }} onClick={e => { add_count(value.blog_id); navigate(`/cramSchool/${page}/${value['blog_id']}`) }}>了解更多</span>
                                                </Col>
                                            </> : null}
                                        </Row>
                                    </Col>
                                </Row >
                            </Card >
                        </Col >
                    )
                } else if (type == 'environment') {
                    return (
                        < Col sm={{ span: 24 }
                        } md={{ span: span }} justify='center' >
                            <Card
                            // style={{ minHeight: "17rem", position: 'relative', alignItems: 'center' }}
                            // style={{ backgroundColor: value.background_color || '#ffffff' }}
                            >
                                <Row gutter={[24, 16]} style={{ minHeight: "15rem", position: 'relative', alignItems: 'center' }}>
                                    <Col span={24} style={{ padding: '50px' }}>
                                        {edit ? <>
                                            <Row style={{ position: 'relative', justifyContent: 'end', }}>
                                                <Col className='example' style={{ position: 'absolute', left: '100%', top: '0%', zIndex: 99 }}>
                                                    <EditOutlined
                                                        className='example'
                                                        style={{
                                                            backgroundColor: '#F9D4E5',
                                                            fontSize: '1.2rem',
                                                            borderRadius: '50%',
                                                            padding: '8px'
                                                        }}
                                                        onClick={e => handleOnEdit(index)}
                                                    />
                                                </Col>
                                            </Row>
                                        </>
                                            : null}
                                        <Carousel_news_ticker
                                            // logo
                                            // height={'100%'}
                                            file_url={value['file_url']} />
                                    </Col>
                                    <Col span={24} >
                                        < Row gutter={[8, 8]} style={{ textAlign: 'center' }}>
                                            <Col span={24}>
                                                <span style={{ fontSize: '1.2rem', fontWeight: 'bold' }}>{value['title']}</span>
                                            </Col>
                                            {dimensions['width'] > 500 &&
                                                (<Col span={24}>
                                                    <Paragraph
                                                        ellipsis={{
                                                            rows: 1,
                                                            expandable: true,
                                                            symbol: 'more',
                                                        }}
                                                    >
                                                        {value?.['content'] && (<>
                                                            {(String(value?.['content']) || '').split('\n').map(map_item => (<>
                                                                {map_item}<br />
                                                            </>))}
                                                        </>)}
                                                    </Paragraph>
                                                </Col>)}
                                        </Row>
                                    </Col>
                                </Row>
                            </Card>
                        </Col>
                    )
                }
            })

            }
        </>
    )
}
export default BlogCard;
const useVisitTime = (props) => {
    const [visit_time, set_visit_time] = useState({});
    const [abort, set_abort] = useState(new AbortController());
    useEffect(() => {
        get_visit_log()
    }, [props.data])
    const get_visit_log = () => {
        let visit_time_temp = {};
        props.data && props.data.forEach((value, index) => {
            visit_time_temp[value.url] = '-'
        });
        set_visit_time(visit_time_temp)
        abort.abort()
        const abort_ = new AbortController()
        axios
            .get('/cramSchool/api/visit_statistics', {
                params: {
                    url: Object.entries(visit_time_temp).map(([map_key, map_value]) => ({ url: map_key }))
                },
                signal: abort_.signal
            })
            .then(response => {
                set_abort(abort_)
                let visit_time_temp = {};
                props.data && props.data.forEach((value, index) => {
                    visit_time_temp[value.url] = '-'
                });
                visit_time_temp = Object.entries(visit_time_temp).reduce((all, [map_key, map_value]) => {
                    let visit_time_ = 0;
                    response.data?.data.forEach(each_item => {
                        if (each_item.url === map_key) {
                            visit_time_ = each_item.visit_time
                        }
                    })
                    return { ...all, [map_key]: visit_time_ }
                })
                set_visit_time(visit_time_temp)
            })
    }
    return visit_time;
}